/**
 * Created by pajicv on 9/28/18.
 */
import React from 'react';
import { FormControl, Select, TextField, InputLabel, withStyles } from '@material-ui/core';
//import DeleteIcon from '@material-ui/icons/Delete';
import validator from 'validator';

const styles = theme => ({
    root: {
        width: 300,
        display: 'flex', 
        flexDirection: 'column'
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    deleteButton: {
        width: 40,
        height: 40
    }
});

class MemberToolbar extends React.Component {

    render() {
        const { classes, role, email, name, onRoleChange, onNameChange, onEmailChange } = this.props;

        const isEmailValid = validator.isEmail(email);

        return (
            <div className={classes.root}>
                <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="name-field">Name</InputLabel>
                    <TextField
                        value={name}
                        margin="normal"
                        onChange={onNameChange}
                        inputProps={{
                            name: 'name',
                            id: 'name-field',
                        }}
                    />
                </FormControl>
                <FormControl required className={classes.formControl}>
                    <InputLabel shrink htmlFor="role-select">Rolle</InputLabel>
                    <Select
                        native
                        value={role}
                        inputProps={{
                            name: 'role',
                            id: 'role-select',
                        }}
                        onChange={onRoleChange}
                    >
                        <option value={'worker'}>Bearbeiter</option>
                        <option value={'co-manager'}>Co-manager</option>
                        <option value={'manager'}>Manager</option>
                    </Select>
                </FormControl>
                <FormControl required className={classes.formControl}>
                    <InputLabel shrink htmlFor="email-field" error={!isEmailValid}>E-mail</InputLabel>
                    <TextField
                        error={!isEmailValid}
                        value={email}
                        type="email"
                        margin="normal"
                        onChange={onEmailChange}
                        inputProps={{
                            name: 'email',
                            id: 'email-field'
                        }}
                    />
                </FormControl>
                {/*
                <Button
                    className={classes.deleteButton}
                    variant="fab"
                    color="red"
                    aria-label="Delete"
                >
                    <DeleteIcon fontSize="small"/>
                </Button>
                */}
            </div>
        );
    }

}

export default withStyles(styles)(MemberToolbar);



// WEBPACK FOOTER //
// ./src/components/Tasks/InviteBar.js